export default __webpack_public_path__ + "media/4.17307f82.jpg";